import BaseBox from '@material-ui/core/Box';
import DateTimePicker, { DateTimePickerProps } from '@material-ui/lab/DateTimePicker';
import { useContextCheckboxWithOptionalContent } from 'components/CheckboxWithOptionalContent';
import { useContextRadioButtonWithOptionalContent } from 'components/RadioButtonWithOptionalContent';
import { TextFieldStyle } from 'components/TextInput';
import React, { useEffect } from 'react';
import styled from 'styled-components';
import { ReactComponent as DateIcon } from './assets/DateIcon.svg';

const Box = styled(BaseBox)`
  .MuiInputAdornment-root {
    padding-right: 4px;
  }

  .MuiIconButton-root {
    width: 39px;
  }

  .Mui-error .MuiOutlinedInput-notchedOutline {
    border-color: #f44336 !important;
  }

  label.MuiFormLabel-filled + .MuiInputBase-root legend {
    padding: 0 2px;
  }
`;
const AdaptDateTimePicker = styled(DateTimePicker)`
  && {
    .MuiInternalClock-meridiemButtonSelected {
      color: #fff;
      background-color: #3f51b5;
    }
    .MuiInternalClock-amButton {
      margin: 0 8px;
    }
    .MuiClock-meridiemButtonSelected {
      color: #fff;
      background-color: #3f51b5;
    }
    .MuiTabs-root {
      .MuiButtonBase-root,
      .MuiButtonBase-root.Mui-selected {
        color: #fff;
      }
    }
  }
`;

type Props = {
  form?: any;
  field?: any;
  editable?: boolean;
  disabled?: boolean;
  fullWidth?: boolean;
};

const KeyboardDateTimePicker: React.VFC<Props & DateTimePickerProps> = ({
  form: { setFieldValue },
  field: { value, name, onChange, ...fields },
  editable,
  disabled,
  fullWidth = false,
  ...rest
}) => {
  const { checked } = useContextCheckboxWithOptionalContent();
  const { valueChecked } = useContextRadioButtonWithOptionalContent();

  useEffect(() => {
    if (checked !== undefined && !checked && setFieldValue && fields.value) {
      setFieldValue(name, undefined);
    }

    if (valueChecked !== undefined && !valueChecked && setFieldValue && fields.value) {
      setFieldValue(name, undefined);
    }
  }, [checked, valueChecked, name, setFieldValue, fields.value]);

  const handleCheckShrinkShow = () => {
    if (!editable) {
      return true;
    }

    return !!value;
  };

  return (
    <Box
      sx={{
        py: 1.25,
        width: fullWidth ? '100%' : 'initial',
      }}
    >
      <AdaptDateTimePicker
        openPickerIcon={<DateIcon />}
        disabled={!editable}
        ampm={false}
        {...fields}
        {...rest}
        value={!value ? null : value}
        onChange={(value: Date) => {
          setFieldValue(name, value);
        }}
        renderInput={({ inputProps, ...params }) => (
          <TextFieldStyle
            {...params}
            margin="normal"
            name={name}
            helperText={null}
            InputLabelProps={{
              shrink: handleCheckShrinkShow(),
            }}
            inputProps={{
              ...inputProps,
              placeholder: editable ? inputProps?.placeholder : '',
            }}
          />
        )}
      />
    </Box>
  );
};

export default KeyboardDateTimePicker;
